import { getCookieValue } from './utils/cookie';

function createElement(assetsToBeLoaded) {
  return assetsToBeLoaded.map(({ type, src }) => {
    let element = {};
    return new Promise((resolve) => {
      switch (type) {
        case 'script':
          element = document.createElement('script');
          element.src = src;
          element.type = 'text/javascript';
          element.async = false;
          element.charset = 'UTF-8';
          element.onload = _elem => resolve(_elem);
          document.body.appendChild(element);
          break;
        case 'link':
          element = document.createElement('link');
          element.href = src;
          element.rel = 'stylesheet';
          element.async = false;
          element.onload = _elem => resolve(_elem);
          document.head.appendChild(element);
          break;
        default: break;
      }
    });
  });
}

export default async function injectRegistrationScripts() {
  const assetsToBeLoaded = [
    { type: 'link', src: 'https://storage.googleapis.com/clientaccess/registration/IntlTelInput/intlInput.css' },
    { type: 'script', src: 'https://storage.googleapis.com/clientaccess/registration/InputValidator.js' },
    { type: 'script', src: 'https://storage.googleapis.com/branding-resources/tz-moment.js' },
    { type: 'script', src: '/ca/assets/dest/js/registrationHelperJS.js?v=19' },
    { type: 'script', src: 'https://storage.googleapis.com/clientaccess/registration/IntlTelInput/intlTelInputUtils.js', defer: false },
  ];

  if ((document.getElementById('registration')) && !document.querySelector("script[src='https://storage.googleapis.com/clientaccess/registration/InputValidator.js']")) {
    const isAppened = await Promise.all(createElement(assetsToBeLoaded)).then(() => true);
    return isAppened;
  }
  return true;
}


export async function injectDefaultScripts() {
  let assetsToBeLoaded = [];

  if (document.getElementById('music') && !document.querySelector("script[src='/ca/assets/dest/js/customAudioPlayer.js']")) {
    assetsToBeLoaded = assetsToBeLoaded.concat([{ type: 'script', src: '/ca/assets/dest/js/customAudioPlayer.js' }]);
  }
  if (document.getElementById('trustbox-widget') && !document.querySelector("script[src='//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js']")) {
    assetsToBeLoaded = assetsToBeLoaded.concat([{ type: 'script', src: '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js', defer: true }]);
  }
  if (document.getElementById('Setmore_button_iframe') && getCookieValue('ca-isregistered') === 'true'
      && !document.querySelector("script[src='https://my.setmore.com/webapp/js/src/others/setmore_iframe.js']")) {
    assetsToBeLoaded.push({
      id: 'setmore_script',
      type: 'script',
      src: 'https://my.setmore.com/webapp/js/src/others/setmore_iframe.js',
      defer: true,
    });
  }

  if (assetsToBeLoaded.length > 0) {
    const isAppened = await Promise.all(createElement(assetsToBeLoaded)).then(() => true);
    return isAppened;
  }
  return true;
}
